"use client";

import clsx from "clsx";

import { Link } from "../../../../../_components/ui/link";
import { SPOT_CATEGORY_TABS } from "../_utils/spot-category";

/**
 * カテゴリチップ (Figma 9088-34: Chip)。 親 <Link> が group。
 * 非選択は hover で stainedhover(#dbd9d0)、 focus-visible で focus 枠線。
 * 選択中 (inverse) は hover 変化なし (Figma に selected hover 状態なし)。
 */
function CategoryChip({ active, label }: { active: boolean; label: string }) {
  return (
    <span
      className={clsx(
        "dx-body-1 flex min-h-[32px] items-center rounded-full px-[12px] whitespace-nowrap transition-colors duration-150",
        "group-focus-visible:ring-dx-border-focus group-focus-visible:ring-[1.5px]",
        active
          ? "bg-dx-bg-inverse text-dx-text-inverse"
          : "bg-dx-surface-subtle text-dx-text-default group-hover:bg-dx-stained-hover",
      )}
    >
      {label}
    </span>
  );
}

export function SpotsCategoryTabs({
  areaSlug,
  activeSlug,
  onSelect,
}: {
  areaSlug: string;
  activeSlug: string | null;
  onSelect: (slug: string | null) => void;
}) {
  return (
    <nav className="flex gap-[4px] overflow-x-auto px-[16px]">
      {SPOT_CATEGORY_TABS.map((category) => {
        const isActive = category.slug === activeSlug;
        // active なタブを再クリックで絞り込み解除。
        const next = isActive ? null : category.slug;
        const href =
          next === null
            ? `/areas/${areaSlug}/spots`
            : `/areas/${areaSlug}/spots?category=${next}`;
        return (
          <div
            key={category.slug}
            className="flex h-[40px] flex-none items-center py-[4px]"
          >
            <Link
              href={href}
              aria-current={isActive ? "page" : undefined}
              className="group rounded-full focus-visible:outline-none"
              data-analytics-id="area_spots_selected_category"
              onClick={(e) => {
                // 通常クリックはクライアント側で即時フィルタ (サーバー往復を回避)。
                // 修飾キークリックは新タブで開く等のブラウザ既定に任せる。
                if (e.metaKey || e.ctrlKey || e.shiftKey) return;
                e.preventDefault();
                onSelect(next);
              }}
            >
              <CategoryChip active={isActive} label={category.label} />
            </Link>
          </div>
        );
      })}
    </nav>
  );
}
